import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q6: PartialCarConfiguration = {
	combinations: [
		'trimLine',
		'equipmentPackages',
		'packages',
		'paint',
		'rims',
		'headlights',
		'interiorPackages',
		'steeringWheels',
	],
	nextBestActions: [
		{
			description: 'Contact met uw dealer',
			icon: '',
			labelText: 'Contact met uw dealer',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://formulieren.audi.nl/#/site/contact-q6',
		},
		{
			description: 'Leasen & offerte ',
			icon: 'dealer-request',
			labelText: 'Leasen & offerte ',
			target: '_blank',
			trackingName: 'online leasing',
			url: 'https://www.audi.nl/nl/web/nl/modellen/q6/q6-e-tron/leasen.html',
		},
	],
};

const sq6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q6etron, q6etron_ui, sq6etron, sq6etron_ui };
